import { useQuery } from "@tanstack/react-query";
import axios from "axios";

// Fetch a srf function
export const fetchSrf = async (clientId, projectId) => {
  try {
    const response = await axios.get(`/api/srf/${clientId}/${projectId}/`, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

// Custom hook to fetch a srf
export default function useSrf(clientId, projectId) {
  return useQuery({
    queryKey: ["srf", clientId, projectId],
    queryFn: () => fetchSrf(clientId, projectId),
    enabled: !!clientId && !!projectId,
  });
}
